import { render } from "./CreaReporte.vue?vue&type=template&id=af4aa06a"
import script from "./CreaReporte.vue?vue&type=script&lang=js"
export * from "./CreaReporte.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__